import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as styles from './shared_bridge_panel.module.css';
export function SharedBridgePanel({ location }) {
    return /*#__PURE__*/ _jsxs("section", {
        className: styles.panel,
        "aria-label": "Shared stylesheet panel",
        children: [
            /*#__PURE__*/ _jsxs("span", {
                className: styles.badge,
                children: [
                    location,
                    " DOM"
                ]
            }),
            /*#__PURE__*/ _jsx("h3", {
                className: styles.title,
                children: "Shared CSS module styles"
            }),
            /*#__PURE__*/ _jsx("p", {
                className: styles.copy,
                children: "The light and shadow DOMs reuse the same hashed class names produced by the CSS module pipeline."
            })
        ]
    });
}
